import { ENV_VARS } from '@/env';
import { API } from '../../api';
import { axiosInstance } from '../../utils/fetcher';

const isHBUser = ENV_VARS.REACT_APP_THEME === 'halliburton';
const CancelToken = axiosInstance.CancelToken;

let getSearchQuoteListEffectCancelToken = () => {};
export const getSearchQuoteListEffect = (data) => {
  getSearchQuoteListEffectCancelToken();
  return axiosInstance.request({
    url: `${API.SPOT_QUOTE}/GetSpotQuoteSearch`,
    method: 'post',
    data: data,
    cancelToken: new CancelToken(function executor(c) {
      getSearchQuoteListEffectCancelToken = c;
    }),
  });
};

let getShipmentListEffectCancelToken = () => {};
export const getShipmentListEffect = (data) => {
  getShipmentListEffectCancelToken();
  return axiosInstance.request({
    url: `${API.SHIPMENT}/shipmentsearch`,
    method: 'get',
    params: data,
    cancelToken: new CancelToken(function executor(c) {
      getShipmentListEffectCancelToken = c;
    }),
  });
};

let getShipmentDetailsCancelToken = () => {};
export const getShipmentDetailsEffect = (data) => {
  getShipmentDetailsCancelToken();
  return axiosInstance.request({
    url: `${API.SHIPMENT}/GetShipment`,
    method: 'get',
    params: data,
    cancelToken: new CancelToken(function executor(c) {
      getShipmentDetailsCancelToken = c;
    }),
  });
};

export const getShipmentStatusListEffect = () => {
  return axiosInstance.request({
    url: `${API.SHIPMENT}/GetShipmentStatus`,
    method: 'get',
  });
};

export const getShipmentStatusListQuote = () => {
  return axiosInstance.request({
    url: `${API.SPOT_QUOTE}/GetSpotQuoteStatuses`,
    method: 'get',
  });
};

export const SetSpotQuoteStatusAwardedEffect = (data) => {
  return axiosInstance.request({
    url: `${API.SPOT_QUOTE}/SetSpotQuoteStatusAwarded`,
    method: 'patch',
    params: data,
  });
};

let getAllTransportationProvidersEffectCancelToken = () => {};
export const getAllTransportationProvidersEffect = (params = {}) => {
  getAllTransportationProvidersEffectCancelToken();
  return axiosInstance.request({
    url: `${API.SHIPMENT}/GetAllTransportationProviders`,
    method: 'get',
    params,
    cancelToken: new CancelToken(function executor(c) {
      getAllTransportationProvidersEffectCancelToken = c;
    }),
  });
};

export const getShipmentCargoTypesEffect = () => {
  return axiosInstance.request({
    url: `${API.SHIPMENT}/GetShipmentCargo`,
    method: 'get',
  });
};

let getShipmentAppointmentTypesEffectCancelToken = () => {};
export const getShipmentAppointmentTypes = () => {
  getShipmentAppointmentTypesEffectCancelToken();
  return axiosInstance.request({
    url: `${API.SHIPMENT}/GetShipmentAppointmentype`,
    method: 'get',
    cancelToken: new CancelToken(function executor(c) {
      getShipmentAppointmentTypesEffectCancelToken = c;
    }),
  });
};

export const getShipmentCreatedBy = (params) => {
  const url = isHBUser ? `${API.SPOT_QUOTE}/GetQuoteCreatedByDetails` : `${API.SHIPMENT}/GetShipmentCreatedByDetails`;

  return axiosInstance.request({
    url,
    method: 'get',
    params,
  });
};

export const getSpotQuoteHistoryData = (spotQuoteId) => {
  return axiosInstance.request({
    url: `${API.SHIPMENT}/GetAuditLogData`,
    method: 'get',
    params: { spotQuoteId },
    headers: { 'Content-Type': 'application/json' },
  });
};

export const getSpotQuoteHistory = (quoteKey) => {
  return axiosInstance.request({
    url: `${API.SPOT_QUOTE}/GetSpotQuoteHistory`,
    method: 'get',
    params: { quoteKey },
    headers: { 'Content-Type': 'application/json' },
  });
};

export const getVendorList = (params) => {
  return axiosInstance.request({
    url: `${API.SHIPMENT}/GetVendorSearch`,
    method: 'get',
    params,
  });
};

let getShipmentPortTypesEffectCancelToken = () => {};
export const getShipmentPortTypes = () => {
  getShipmentPortTypesEffectCancelToken();
  return axiosInstance.request({
    url: `${API.SHIPMENT}/GetShipmentPortType`,
    method: 'get',
    cancelToken: new CancelToken(function executor(c) {
      getShipmentPortTypesEffectCancelToken = c;
    }),
  });
};

export const getShipmentPortCodes = (params) => {
  return axiosInstance.request({
    url: `${API.SHIPMENT}/GetPortCode`,
    method: 'get',
    params,
  });
};

export const getShipmentPortList = (data) => {
  return axiosInstance.request({
    url: `${API.PRIMARY}/GetPortSearch`,
    method: 'post',
    data,
  });
};

let getShipmentStopTypesEffectCancelToken = () => {};
export const getShipmentStopTypes = () => {
  getShipmentStopTypesEffectCancelToken();
  return axiosInstance.request({
    url: `${API.SHIPMENT}/GetShipmentStopType`,
    method: 'get',
    cancelToken: new CancelToken(function executor(c) {
      getShipmentStopTypesEffectCancelToken = c;
    }),
  });
};

export const getShipmentStopSequence = (params) => {
  return axiosInstance.request({
    url: `${API.SHIPMENT}/GetShipmentStopSequence`,
    method: 'get',
    params,
  });
};

export const getIncortermListEffect = () => {
  return axiosInstance.request({
    url: `${API.SHIPMENT}/GetIncoTerm`,
    method: 'get',
  });
};

export const gerFreeOnBoardEffect = () => {
  return axiosInstance.request({
    url: `${API.SHIPMENT}/GetAllFreeOnBoard`,
    method: 'get',
  });
};

export const getCarrierListEffect = (params = {}) => {
  return axiosInstance.request({
    url: `${API.POV}/GetCarrier`,
    method: 'get',
    params,
  });
};

let getProductUOMListTypesEffectCancelToken = () => {};
export const getProductUOMListTypesEffect = () => {
  getProductUOMListTypesEffectCancelToken();
  return axiosInstance.request({
    url: `${API.SHIPMENT}/GetProductUnitUom`,
    method: 'get',
    cancelToken: new CancelToken(function executor(c) {
      getProductUOMListTypesEffectCancelToken = c;
    }),
  });
};

export const getPalletLoadTypeListEffect = () => {
  return axiosInstance.request({
    url: `${API.SHIPMENT}/GetProductPalletLoadType`,
    method: 'get',
  });
};

export const getWeightUomEffect = () => {
  return axiosInstance.request({
    url: `${API.POV}/GetWeightUnitOfMeasure`,
    method: 'get',
  });
};
let getProductDimUomListEffectCancelToken = () => {};
export const getProductDimUomListEffect = () => {
  getProductDimUomListEffectCancelToken();
  return axiosInstance.request({
    url: `${API.SHIPMENT}/GetProductDimUom`,
    method: 'get',
    cancelToken: new CancelToken(function executor(c) {
      getProductDimUomListEffectCancelToken = c;
    }),
  });
};

export const getProductsEffect = (params = {}) => {
  return axiosInstance.request({
    url: `${API.SHIPMENT}/GetProductSearchbySingleRequest`,
    method: 'get',
    params,
  });
};

export const getRatingPreferenceEffect = () => {
  return axiosInstance.request({
    url: `${API.SHIPMENT}/GetAllRatingPreferences`,
    method: 'get',
  });
};

export const getZipCodeDetailsEffect = (params) => {
  return axiosInstance.request({
    url: `${API.SHIPMENT}/GetZipCodeDetails`,
    method: 'get',
    params,
  });
};

export const getServiceLevelEffect = (params = {}) => {
  return axiosInstance.request({
    url: `${API.SHIPMENT}/GetShipmentServiceLevel`,
    method: 'get',
    params,
  });
};

let getShipperSearchEffectCancelToken = () => {};
export const getShipperSearchEffect = (params = {}) => {
  getShipperSearchEffectCancelToken();
  return axiosInstance.request({
    url: `${API.SHIPMENT}/GetShipperSearch`,
    method: 'get',
    params,
    cancelToken: new CancelToken(function executor(c) {
      getShipperSearchEffectCancelToken = c;
    }),
  });
};

let getConsigneeSearchEffectCancelToken = () => {};
export const getConsigneeSearchEffect = (params = {}) => {
  getConsigneeSearchEffectCancelToken();
  return axiosInstance.request({
    url: `${API.SHIPMENT}/GetConsigneeSearch`,
    method: 'get',
    params,
    cancelToken: new CancelToken(function executor(c) {
      getConsigneeSearchEffectCancelToken = c;
    }),
  });
};

export const generateShipmentNoEffect = (params) => {
  return axiosInstance.request({
    url: `${API.SHIPMENT}/GenerateShipmentNumber`,
    method: 'get',
    params,
  });
};

export const generateApprovalNoEffect = (params) => {
  return axiosInstance.request({
    url: `${API.SHIPMENT}/GenerateApprovalNumber`,
    method: 'get',
    params,
  });
};

export const getSportBidExpireTimeEffect = (params = {}) => {
  return axiosInstance.request({
    url: `${API.SHIPMENT}/GetSpotBidExpirationTime`,
    method: 'get',
    params,
  });
};

export const getTimeZonesEffect = () => {
  return axiosInstance.request({
    url: `${API.SHIPMENT}/GetTimeZone`,
    method: 'get',
  });
};

export const getTimeZonesEffectForHB = () => {
  return axiosInstance.request({
    url: `${API.PRIMARY}/GetTimeZones`,
    method: 'get',
  });
};

export const saveShipmentDetailsEffect = (data) => {
  return axiosInstance.request({
    url: `${API.SHIPMENT}/ModifyShipment`,
    method: 'post',
    data: JSON.stringify(data),
    headers: { 'Content-Type': 'application/json' },
  });
};

let locationSearchEffectCancelToken = () => {};
export const locationSearchEffect = (params = {}) => {
  locationSearchEffectCancelToken();
  return axiosInstance.request({
    url: `${API.SHIPMENT}/GetLocationSearch`,
    method: 'get',
    params,
    cancelToken: new CancelToken(function executor(c) {
      locationSearchEffectCancelToken = c;
    }),
  });
};

export const deleteShipmentsEffect = (data) => {
  return axiosInstance.request({
    url: `${API.SHIPMENT}/DeleteShipment`,
    method: 'post',
    params: data,
  });
};

export const copyShipmentEffect = (data) => {
  return axiosInstance.request({
    url: `${API.SHIPMENT}/CopyShipment`,
    method: 'post',
    params: data,
  });
};

export const consolidateShipmentsEffect = (data) => {
  return axiosInstance.request({
    url: `${API.SHIPMENT}/ShipmentConsolidation`,
    method: 'get',
    params: data,
  });
};

export const updateShipmentStatusEffect = (data) => {
  return axiosInstance.request({
    url: `${API.SHIPMENT}/ShipmentStatusChange`,
    method: 'post',
    headers: { 'Content-Type': 'application/json' },
    data,
  });
};

export const getShipmentProductClassEffect = () => {
  return axiosInstance.request({
    url: `${API.SHIPMENT}/GetProductClass`,
    method: 'get',
  });
};

export const createShipmentEffect = (data) => {
  return axiosInstance.request({
    url: `${API.SHIPMENT}/CreateShipment`,
    method: 'post',
    headers: { 'Content-Type': 'application/json' },
    data,
  });
};

export const shipmentSpotBidEffect = (data) => {
  return axiosInstance.request({
    url: `${API.SHIPMENT}/SpotBidShipment`,
    method: 'post',
    data,
  });
};

export const shipmentAddBidderEffect = (data) => {
  return axiosInstance.request({
    url: `${API.SHIPMENT}/SpotBidAddBidder`,
    method: 'post',
    data,
  });
};

export const getShipmentRateShopListEffect = (data) => {
  // TODO: double check
  return axiosInstance.post(`${API.BASE_ORIGIN}/rateengine/rateall`, data);
};

export const getShipmentExportDetails = (data) => {
  return axiosInstance.request({
    url: `${API.SHIPMENT}/GetShipmentExportDetailsPost`,
    method: 'post',
    data,
  });
};

export const shipmentEndSpotBidEffect = (params) => {
  return axiosInstance.request({
    url: `${API.SHIPMENT}/EndShipmentSpotBid`,
    method: 'post',
    params,
  });
};

export const getShipmentDocumentListEffect = (params) => {
  return axiosInstance.request({
    url: `${API.SHIPMENT}/GetAllShipmentDocuments`,
    method: 'get',
    params,
  });
};

export const shipmentFileUploadEffect = (data) => {
  return axiosInstance.request({
    url: `${API.SHIPMENT}/UploadShipmentDocument`,
    method: 'post',
    headers: { 'Content-Type': 'multipart/form-data' },
    data,
  });
};

export const shipmentFileDeleteEffect = (params) => {
  return axiosInstance.request({
    url: `${API.SHIPMENT}/DeleteShipmentDocument`,
    method: 'delete',
    params,
  });
};

export const shipmentFileUpdateEffect = (data) => {
  return axiosInstance.request({
    url: `${API.SHIPMENT}/UpdateShipmentDocument`,
    method: 'post',
    headers: { 'Content-Type': 'multipart/form-data' },
    data,
  });
};

export const getShipmentDefaultAccessorialsForCustomerEffect = (params) => {
  return axiosInstance.request({
    url: `${API.SHIPMENT}/GetShipmentAccessorialsForCustomer`,
    method: 'get',
    params,
  });
};

export const getShipmentTenderEmailEffect = (params) => {
  return axiosInstance.request({
    url: `${API.SHIPMENT}/GetTenderEmailAddress`,
    method: 'get',
    params,
  });
};

export const shipmentTenderProcessEffect = (params) => {
  return axiosInstance.request({
    url: `${API.SHIPMENT}/ShipmentTenderProcess`,
    method: 'post',
    params,
  });
};

export const getShipmentSpotBidDataEffect = (params) => {
  return axiosInstance.request({
    url: `${API.SHIPMENT}/GetSpotBidCarrierListForShipment`,
    method: 'get',
    params,
  });
};

export const shipmentPartialSaveEffect = ({ URL, ...data }) => {
  return axiosInstance.request({
    url: `${API.SHIPMENT}/${URL}`,
    method: 'post',
    data,
  });
};

export const shipmentPartialSaveNotesEffect = (params) => {
  return axiosInstance.request({
    url: `${API.SHIPMENT}/ShipmentPartialSaveNotes`,
    method: 'post',
    params,
  });
};

export const shipmentCalculateMileageEffect = (params) => {
  return axiosInstance.request({
    url: `${API.SHIPMENT}/CalculateShipmentMileage`,
    method: 'post',
    params,
  });
};

export const getPostalSearchEffect = (params) => {
  return axiosInstance.request({
    url: `${API.SHIPMENT}/GetPostalSearch`,
    method: 'get',
    params,
  });
};

export const saveRateShopResultEffect = (data) => {
  return axiosInstance.request({
    url: `${API.SHIPMENT}/AddRateShopData`,
    method: 'post',
    data: JSON.stringify(data),
    headers: { 'Content-Type': 'application/json' },
  });
};

let getShipmentBolCancelToken = () => {};
export const getShipmentBolEffect = (data) => {
  getShipmentBolCancelToken();
  return axiosInstance.request({
    url: `${API.SHIPMENT}/GetBOL`,
    method: 'post',
    params: data,
    cancelToken: new CancelToken(function executor(c) {
      getShipmentBolCancelToken = c;
    }),
  });
};

let getShipmentCommercialInvoiceCancelToken = () => {};
export const getShipmentCommercialInvoiceEffect = (data) => {
  getShipmentCommercialInvoiceCancelToken();
  return axiosInstance.request({
    url: `${API.SHIPMENT}/GetCommercialInvoice`,
    method: 'post',
    params: data,
    cancelToken: new CancelToken(function executor(c) {
      getShipmentCommercialInvoiceCancelToken = c;
    }),
  });
};

let getShipmentPackingListCancelToken = () => {};
export const getShipmentPackingListEffect = (data) => {
  getShipmentPackingListCancelToken();
  return axiosInstance.request({
    url: `${API.SHIPMENT}/GetPackingList`,
    method: 'post',
    params: data,
    cancelToken: new CancelToken(function executor(c) {
      getShipmentPackingListCancelToken = c;
    }),
  });
};

let saveShipmentCommercialInvoiceCancelToken = () => {};
export const saveShipmentCommercialInvoiceEffect = (data) => {
  saveShipmentCommercialInvoiceCancelToken();
  return axiosInstance.request({
    url: `${API.SHIPMENT}/SaveCommercialInvoice`,
    method: 'post',
    data: data,
    cancelToken: new CancelToken(function executor(c) {
      saveShipmentCommercialInvoiceCancelToken = c;
    }),
  });
};

export const getShipmentCustomerRoutingsSettingsEffect = (params) => {
  return axiosInstance.request({
    url: `${API.SHIPMENT}/customerroutingsettings`,
    method: 'get',
    params,
  });
};

export const saveShipmentAddressBookEffect = (data) => {
  return axiosInstance.request({
    url: `${API.SHIPMENT}/SaveAddressBook`,
    method: 'post',
    data,
  });
};

export const deleteShipmentAddressBookEffect = (params) => {
  return axiosInstance.request({
    url: `${API.SHIPMENT}/DeleteAddressBookRecord`,
    method: 'delete',
    params,
  });
};

export const saveShipmentProductEffect = (data) => {
  return axiosInstance.request({
    url: `${API.SHIPMENT}/AddProduct`,
    method: 'post',
    data,
  });
};

export const saveShipmentRateShopFiltersEffect = (data) => {
  return axiosInstance.request({
    url: `${API.SHIPMENT}/ShipmentPartialSaveRatingDetails`,
    method: 'post',
    data,
  });
};

export const updateShipmentStatusToRatedEffect = (params) => {
  return axiosInstance.request({
    url: `${API.SHIPMENT}/UpdateStatusChangeToRated`,
    method: 'post',
    params,
  });
};

export const getShipmentItrackEffect = (params) => {
  return axiosInstance.request({
    url: `${API.SHIPMENT}/GetShipmentITrackData`,
    method: 'get',
    params,
  });
};

export const sendMailShipmentDocumentEffect = ({ data, params }) => {
  return axiosInstance.request({
    url: `${API.SHIPMENT}/SendMailForDocument`,
    method: 'post',
    params,
    data,
    headers: { 'Content-Type': 'multipart/form-data' },
  });
};

export const checkAddressBookIsExistEffect = (params) => {
  return axiosInstance.request({
    url: `${API.SHIPMENT}/CheckAddressbookResult`,
    method: 'get',
    params,
  });
};

export const saveShipmentItrackEffect = (data) => {
  return axiosInstance.request({
    url: `${API.SHIPMENT}/AddShipmentITrackData`,
    method: 'post',
    data,
  });
};

export const getShipmentNotificationRoutingEffect = (params) => {
  return axiosInstance.request({
    url: `${API.SHIPMENT}/GetShipmentNotificationRouting`,
    method: 'get',
    params,
  });
};

export const getShipmentNotificationDistributorsEffect = (params) => {
  return axiosInstance.request({
    url: `${API.SHIPMENT}/GetShipmentDistributionList`,
    method: 'get',
    params,
  });
};

export const createShipmentNotificationDistributorsEffect = (data) => {
  return axiosInstance.request({
    url: `${API.SHIPMENT}/CreateDistributionList`,
    method: 'post',
    data,
  });
};

export const updateShipmentNotificationDistributorsEffect = (data) => {
  return axiosInstance.request({
    url: `${API.SHIPMENT}/UpdateDistributionList`,
    method: 'post',
    data,
  });
};

export const getRateDetailsWithConvertedCurrencyEffect = (data) => {
  return axiosInstance.request({
    url: `${API.SHIPMENT}/GetShipmentRateShopAPI`,
    method: 'post',
    data,
  });
};

export const deleteShipmentNotificationDistributorsEffect = (data) => {
  return axiosInstance.request({
    url: `${API.SHIPMENT}/DeleteDistributionList`,
    method: 'post',
    data,
  });
};

export const createShipmentNotificationRoutingEffect = (data) => {
  return axiosInstance.request({
    url: `${API.SHIPMENT}/CreateNotificationRouting`,
    method: 'post',
    data,
  });
};

export const updateShipmentNotificationRoutingEffect = (data) => {
  return axiosInstance.request({
    url: `${API.SHIPMENT}/UpdateNotificationRouting`,
    method: 'post',
    data,
  });
};

export const deleteShipmentNotificationRoutingEffect = (data) => {
  return axiosInstance.request({
    url: `${API.SHIPMENT}/DeleteNotificationRouting`,
    method: 'post',
    data,
  });
};

export const getShipmentCustomerAddressBookSearchEffect = (params) => {
  return axiosInstance.request({
    url: `${API.SHIPMENT}/GetAddressbookSearch`,
    method: 'get',
    params,
  });
};

export const getShipmentAllAccessorialsEffect = (params) => {
  return axiosInstance.request({
    url: `${API.SHIPMENT}/GetShipmentAccessorials`,
    method: 'get',
    params,
  });
};

export const createShipmentQuoteEffect = (data) => {
  return axiosInstance.request({
    url: `${API.SHIPMENT}/CreateQuote/V1`,
    method: 'post',
    data,
  });
};

export const saveShipmentAccessorialsPartialEffect = (data) => {
  return axiosInstance.request({
    url: `${API.SHIPMENT}/UpdatePartialShipmentAccessorialDetails`,
    method: 'post',
    data,
  });
};

export const saveShipmentTaxesPartialEffect = (data) => {
  return axiosInstance.request({
    url: `${API.SHIPMENT}/UpdatePartialShipmentTaxDetails`,
    method: 'post',
    data,
  });
};

export const createShipmentFromQuoteEffect = (params) => {
  return axiosInstance.request({
    url: `${API.SHIPMENT}/CreateShipmentFromQuote`,
    method: 'post',
    params,
  });
};

export const getMilageByStopsEffect = (data) => {
  return axiosInstance.request({
    baseURL: `${ENV_VARS.REACT_APP_ORIGIN_API}/api/pcmiler/getstopmileage`,
    method: 'post',
    data,
  });
};

export const getBrachAccountNumbersEffect = (params = {}) => {
  return axiosInstance.request({
    url: `${API.SHIPMENT}/GetAccountNumber`,
    method: 'POST',
    params,
  });
};

export const getParcelExpressRatesEffect = (data = {}) => {
  if (data?.vendorService === true) {
    return axiosInstance.request({
      url: `${API.POV}/GetVendorSmallParcelRate`,
      method: 'POST',
      data,
    });
    // biome-ignore lint/style/noUselessElse: <explanation>
  } else {
    return axiosInstance.request({
      url: `${API.SHIPMENT}/GetSmallParcelRate`,
      method: 'POST',
      data,
    });
  }
};

export const createParcelExpressShipmentEffect = (data = {}) => {
  if (data?.vendorService === true) {
    return axiosInstance.request({
      url: `${API.POV}/CreateVendorSmallParcelShipmentLabel`,
      method: 'POST',
      data,
    });
    // biome-ignore lint/style/noUselessElse: <explanation>
  } else {
    return axiosInstance.request({
      url: `${API.SHIPMENT}/CreateSmallParcelShipmentLabel`,
      method: 'POST',
      data,
    });
  }
};

let getShipmentFieldsVisibilityEffectCancelToken = () => {};
export const getShipmentFieldsVisibilityEffect = () => {
  getShipmentFieldsVisibilityEffectCancelToken();
  return axiosInstance.request({
    url: `${API.SHIPMENT}/GetShipmentFieldsVisiblity`,
    method: 'get',
    cancelToken: new CancelToken(function executor(c) {
      getShipmentFieldsVisibilityEffectCancelToken = c;
    }),
  });
};

export const validateAndGetApproversEffect = (params = {}) => {
  return axiosInstance.request({
    url: `${API.SHIPMENT}/ShipmentApprovalProcess`,
    method: 'post',
    params,
  });
};

export const createChildShipmentEffect = (params = {}) => {
  return axiosInstance.request({
    url: `${API.SHIPMENT}/ShipmentChildShipment`,
    method: 'get',
    params,
  });
};

export const sendShipmentApprovalEffect = (data = {}) => {
  return axiosInstance.request({
    url: `${API.SHIPMENT}/ApprovalProcess`,
    method: 'POST',
    data,
  });
};

export const shipmentAddRateEntryEffect = (data) => {
  return axiosInstance.request({
    url: `${API.SHIPMENT}/AddShipmentRateEntry`,
    method: 'post',
    data,
  });
};

export const shipmentValidateRateEntryEffect = (params) => {
  return axiosInstance.request({
    url: `${API.SHIPMENT}/ValidateShipmentRateEntry`,
    method: 'post',
    params,
  });
};

export const shipmentRemoveRateEntryEffect = (params) => {
  return axiosInstance.request({
    url: `${API.SHIPMENT}/DeleteShipmentRateEntry`,
    method: 'post',
    params,
  });
};

export const getMasterChildShipmentDetailsEffect = (params) => {
  return axiosInstance.request({
    url: `${API.SHIPMENT}/GetMasterChildInfoDetails`,
    method: 'get',
    params,
  });
};

export const generateAutomaticProNumber = (data) =>
  axiosInstance.request({
    url: `${API.SHIPMENT}/CustomerProNumberAssignment`,
    method: 'POST',
    data,
  });

export const shipmentUpdateRateEntryEffect = (data) => {
  return axiosInstance.request({
    url: `${API.SHIPMENT}/UpdateShipmentRateEntry`,
    method: 'post',
    data,
  });
};

export const getProductDetailsByCodeEffect = (params) => {
  return axiosInstance.request({
    url: `${API.SHIPMENT}/GetProductSearchbyCodeExactMatch`,
    method: 'get',
    params,
  });
};

export const createPartialShipmentEffect = (data) => {
  return axiosInstance.request({
    url: `${API.SHIPMENT}/ShipmentPartialSaveProcess`,
    method: 'post',
    headers: { 'Content-Type': 'application/json' },
    data,
  });
};

export const convertPartialToShipmentEffect = (data) => {
  return axiosInstance.request({
    url: `${API.SHIPMENT}/UpdatePartialToNewShipment`,
    method: 'post',
    headers: { 'Content-Type': 'application/json' },
    data,
  });
};

export const getShipmentBranchAddressEffect = (params) => {
  return axiosInstance.request({
    url: `${API.SHIPMENT}/GetShipmentBranchAddress`,
    method: 'get',
    params,
  });
};

export const getShipmentsStopsEffect = (params) => {
  return axiosInstance.request({
    url: `${API.SHIPMENT}/GetShipmentStopsById`,
    method: 'get',
    params,
  });
};

export const getParcelExpressDashboardDataEffect = (params) => {
  return axiosInstance.request({
    url: `${API.SHIPMENT}/GetParcelShipmentDashboard`,
    method: 'get',
    params,
  });
};

export const getShipmentTableViewColumn = (GridName = 'Shipment') => {
  return axiosInstance.request({
    url: `${API.SECURITY}/GetGridColumnOptions`,
    method: 'get',
    params: { GridName: GridName },
  });
};

export const saveShipmentTableViewColumn = (data) => {
  return axiosInstance.request({
    url: `${API.SECURITY}/SaveGridColumnOption`,
    method: 'post',
    data,
  });
};

export const getShipmentAPIRateShopListEffect = (data) => {
  return axiosInstance.request({
    baseURL: ENV_VARS.REACT_APP_API_RATESHOP_API,
    method: 'post',
    data,
    auth: {
      username: ENV_VARS.REACT_APP_API_RATESHOP_API_USER_NAME,
      password: ENV_VARS.REACT_APP_API_RATESHOP_API_USER_PASSWORD,
    },
  });
};

export const getShipmentProductListEffect = (params) => {
  return axiosInstance.request({
    url: `${API.SHIPMENT}/GetShipmentProductDetailsWithTotalCount`,
    method: 'get',
    params,
  });
};

export const getShipmentProductFullListEffect = (params) => {
  return axiosInstance.request({
    url: `${API.SHIPMENT}/GetShipmentProductDetails`,
    method: 'get',
    params,
  });
};

export const updateShipmentProductFBCLassEffect = (data) => {
  return axiosInstance.request({
    url: `${API.SHIPMENT}/UpdateShipmentFreightClass`,
    method: 'post',
    data,
  });
};

export const shipmentNmfcCalculateEffect = (params) => {
  return axiosInstance.request({
    url: `${API.SHIPMENT}/NMFCFreightCalulation`,
    method: 'get',
    params,
  });
};

export const getAPIRateShopByWrapperAPIEffect = (data) => {
  return axiosInstance.request({
    url: `${API.SHIPMENT}/GetAPIRateshop`,
    method: 'post',
    data,
  });
};

let getCarriersForCollectShipmentEffectCancelToken = () => {};
export const getCarriersForCollectShipmentEffect = (params = {}) => {
  getCarriersForCollectShipmentEffectCancelToken();
  return axiosInstance.request({
    url: `${API.SHIPMENT}/GetShipmentCollectCarrier`,
    method: 'get',
    params,
    cancelToken: new CancelToken(function executor(c) {
      getCarriersForCollectShipmentEffectCancelToken = c;
    }),
  });
};

export const updateShipmentBOLCarrierEffect = (data) => {
  return axiosInstance.request({
    url: `${API.SHIPMENT}/UpdateBOLCarrierSave`,
    method: 'post',
    data,
  });
};

export const getShipmentAdvancePlanningNoticeEmailsEffect = (params) => {
  return axiosInstance.request({
    url: `${API.SHIPMENT}/GetAdvancePlanningEmailAddress`,
    method: 'get',
    params,
  });
};

export const sendShipmentAdvancePlanningNoticeEmailEffect = (data) => {
  return axiosInstance.request({
    url: `${API.SHIPMENT}/ShipmentAdvancePlanningProcess`,
    method: 'post',
    data,
  });
};

export const getPalletPackageTypesEffect = () => {
  return axiosInstance.request({
    url: `${API.SHIPMENT}/GetShipmentPalletPackageType`,
    method: 'get',
  });
};

// todo refactor it (SPOT QUOTE STATE)

export const getSpotQuoteBiddersEffect = (params) => {
  return axiosInstance.request({
    url: `${API.SPOT_QUOTE_V2}/carriers/bidding-details`,
    method: 'get',
    params,
  });
};

export const searchSpotQuoteBiddersEffect = (params) => {
  const url = isHBUser
    ? `${API.SPOT_QUOTE}/SearchAllRoutingGuideCarriers`
    : `${API.SPOT_QUOTE_ROUTING_GUIDE_V2}/carriers/search`;

  return axiosInstance.request({
    url,
    method: 'get',
    params,
  });
};

export const addQuoteBiddersEffect = (data) => {
  return axiosInstance.request({
    url: `${API.SPOT_QUOTE}/PatchBidingCarrier`,
    method: 'patch',
    data,
  });
};

// was removed by merge with HB
// remove this comment later
// export const addSpotQuoteBiddersEffect = (data) => {
//   return axiosInstance.request({
//     url: `${API.SPOT_QUOTE}/PatchBidingCarrier`,

export const addSpotQuoteBiddersEffect = (data) => {
  return axiosInstance.request({
    url: `${API.SPOT_QUOTE}/PatchSpotBidCarriers`,
    method: 'patch',
    data,
  });
};

export const deleteSpotQuoteBiddersEffect = (params) => {
  return axiosInstance.request({
    url: `${API.SPOT_QUOTE}/DeleteBidingCarrier`,
    method: 'delete',
    params,
  });
};

export const setSpotQuoteStatusAwardedEffect = (params) => {
  return axiosInstance.request({
    url: `${API.SPOT_QUOTE}/SetSpotQuoteStatusAwarded`,
    method: 'patch',
    params,
  });
};

export const searchSpotQuoteCollaboratorsEffect = (params) => {
  const url = isHBUser
    ? `${API.SPOT_QUOTE}/SearchAllRoutingGuideCollaborators`
    : `${API.SPOT_QUOTE_ROUTING_GUIDE_V2}/collaborators/search`;

  return axiosInstance.request({
    url,
    method: 'get',
    params,
  });
};

export const deleteShipmentTenderProcessEffect = (params) => {
  return axiosInstance.request({
    url: `${API.SHIPMENT}/DeleteShipmentTenderRateEntryData`,
    method: 'post',
    params,
  });
};

export const getSpotQuoteCollaboratorsEffect = (spotQuoteId) => {
  return axiosInstance.request({
    url: `${API.SPOT_QUOTE_V2}/collaborators/${spotQuoteId}`,
    method: 'get',
    params: { spotQuoteId },
  });
};

export const addSpotQuoteCollaboratorsEffect = (data) => {
  return axiosInstance.request({
    url: `${API.SPOT_QUOTE}/PatchSpotQuoteCollaborator`,
    method: 'patch',
    data,
  });
};

export const deleteSpotQuoteCollaboratorsEffect = (data) => {
  return axiosInstance.request({
    url: `${API.SPOT_QUOTE}/DeleteSpotQuoteCollaborator`,
    method: 'delete',
    data,
  });
};

export const getShipperAccountNumberListEffect = (params) => {
  return axiosInstance.request({
    url: `${API.SHIPMENT}/GetShipperAccountNumber`,
    method: 'get',
    params,
  });
};

export const getDutyAndTaxNumberListEffect = (params) => {
  return axiosInstance.request({
    url: `${API.SHIPMENT}/GetTaxDuityNumber`,
    method: 'get',
    params,
  });
};

export const getAccountNumberInfo = (accountNumber) => {
  return axiosInstance.request({
    url: `${API.SHIPMENT}/GetAccountInfo`,
    method: 'get',
    params: { accountNumber },
  });
};

export const getQuoteAwardReasonsEffect = () => {
  return axiosInstance.request({
    url: `${API.SPOT_QUOTE}/GetQuoteAwardReasons`,
    method: 'get',
  });
};

export const getShipmentVendorPortSearch = (params) => {
  return axiosInstance.request({
    url: `${API.SHIPMENT}/GetVendorPortSearch`,
    method: 'get',
    params,
  });
};

export const getCargoSpecificAccessorialsEffect = (params) => {
  return axiosInstance.request({
    url: `${API.SHIPMENT}/GetShipmentCargoTypeAccessorials`,
    method: 'get',
    params,
  });
};

export const checkAddressExistEffect = (data) => {
  return axiosInstance.request({
    url: `${API.SHIPMENT}/CheckAddressExist`,
    method: 'post',
    data,
  });
};
